import { createFileRoute } from '@tanstack/react-router';
import { AssetDetailPage } from '@/features/work-orders/components/asset-detail/AssetDetailPage';

export const Route = createFileRoute('/_authenticated/assets/$id/')({
	component: AssetDetail,
});

function AssetDetail() {
	const { id } = Route.useParams();
	return <AssetDetailPage id={id} />;
}
